import { NgModule } from '@angular/core';
import { INav } from "./interfaces/inav";
import { IColumns } from "./interfaces/IColumns.interface";
import { ILookup } from "./interfaces/ILookup.interface";
import { IGrid } from "./interfaces/IGrid";
import { IDataService } from "./interfaces/IDataService";
import { IChangeset } from "./interfaces/IChangeset";
import { ILogger } from "./interfaces/ILogger";
import { BIObservable } from "./interfaces/observable";
import { INavBtn } from "./interfaces/inav-btn";
import { IErrorMessages } from "./interfaces/IErrorMessages";
import { ICreateDialog } from "./interfaces/ICreateDialog";
import { IDialog } from "./interfaces/IDialog";
import { ITree } from "./interfaces/ITree";
import { IBiAnchorPopup } from "./interfaces/IBiAnchorPopup";
import { IGallery } from "./interfaces/IGallery";
import { ExtendedMap } from './interfaces/ExtendedMap';
import { ILayoutSaver } from './interfaces/IlayoutSaver';
import { IUIProfileService } from './interfaces/IUIProfileService';
import { IColumnConfig } from './interfaces/IColumnConfig';
//import { ExtendedMap } from './ExtendedMap';
@NgModule({
  declarations: [
  ],
  imports: [
  ],
  exports: [
  ],
  providers: [
   // ExtendedMap
  ]
})
export class BIInterfacesModule { }
